import _ from 'lodash';
import rosetta from 'rosetta';

export const LOCALE_EN = 'en';
export const lsI18nService = {
    _private: {
        i18n: null,
    },

    init() {
        if (this._private.i18n) {
            return;
        }

        this._private.i18n = rosetta();
        const [targetLocale] = _.split(navigator.language, '-');
        this._private.i18n.locale(targetLocale);
    },

    addLocale(locale, dict) {
        this._private.i18n.set(locale, dict);
    },

    getLocale() {
        return this._private.i18n.locale();
    },

    setLocale(locale) {
        this._private.i18n.locale(locale);
    },

    translate(key, params) {
        return this._private.i18n.t(key, params);
    },
};
